<template>
    <div class="mb-2">
        <div v-for="(value,key) in items" :key="key">
            <ReMarkdown v-if="isMarkdown(key)" :value="key" /><span v-else class="key">{{ key }}</span>:
            <ReNoteJsonValue :value="value" />
        </div>
    </div>
</template>

<script>
import ReNoteJsonValue from './ReNoteJsonValue.vue';
import ReMarkdown from './ReMarkdown.vue';

export default {
    name: 'ReNoteJsonItem',
    props: {
        items: {
            type: Object,
            required: true
        }
    },
    components: {
        ReNoteJsonValue,
        ReMarkdown
    },
    methods: {
        isMarkdown(value) {
            // Проверяем, содержит ли значение markdown-разметку
            const markdownPatterns = [
                /^#/, // Заголовки
                /^_/, // Заголовки
                /^~/, // Заголовки
                /^-/, // Списки
                /^\*/, // Списки
                /^\+/, // Списки
                /^`/, // Код
                /\*\*/, // Жирный текст
                /\*/, // Курсив
                /^> / // Цитаты
            ];
            
            for (const pattern of markdownPatterns) {
                if (pattern.test(value)) {
                    return true;
                }
            }
            return false;
        }
    }
}
</script>
